import Image from "next/image";
import { useRouter } from "next/navigation";

export default function BlogCard({ blog }) {
  const router = useRouter();

  return (
    <div className="bg-white rounded-md border-2 border-gray-200 px-4 w-95 h-125 py-4 overflow-hidden hover:shadow-xl hover:border-red-800 transition-all">

      <div className="relative h-50 w-full">
        <Image
          src={ "/blog1.webp"} 
          // src={blog.blog_image || "/blog1.webp"} 
          alt={blog.blog_title || "Blog Image"}
          fill
          className="object-cover"
        />
      </div>

      <div className="py-4">

        {/* ✅ Title */}
        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
          {blog.blog_title}
        </h3>

        {/* ✅ Date */}
        <p className="text-sm text-blue-600 mb-2">
          Posted on {new Date(blog.created_date).toDateString()}
        </p>

        {/* ✅ Description (optional if exists) */}
        {blog.blog_content && (
          <p className="text-gray-700 text-sm mb-4 line-clamp-4">
            {blog.blog_content.replace(/<[^>]+>/g, "").slice(0, 120)}...
          </p>
        )}

        {/* ✅ Button */}
        <button
          onClick={() => router.push(`/blogs/${blog.blog_slug}`)}
          className="bg-red-800 text-white mt-3 px-4 py-2 rounded-md text-sm font-semibold hover:bg-red-900 transition"
        >
          Read More +
        </button>
      </div>
    </div>
  );
}
